import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "hero_eyebrow_tr", label: "Hero üst etiket (TR)", textarea: false },
  { key: "hero_eyebrow_en", label: "Hero eyebrow (EN)", textarea: false },
  { key: "hero_title_tr", label: "Hero başlık (TR)", textarea: true },
  { key: "hero_title_en", label: "Hero title (EN)", textarea: true },
  { key: "hero_subtitle_tr", label: "Hero alt metin (TR)", textarea: true },
  { key: "hero_subtitle_en", label: "Hero subtitle (EN)", textarea: true },
  { key: "intro_title_tr", label: "Tanıtım başlık (TR)", textarea: true },
  { key: "intro_title_en", label: "Intro title (EN)", textarea: true },
  { key: "intro_body_tr", label: "Tanıtım metni (TR)", textarea: true },
  { key: "intro_body_en", label: "Intro body (EN)", textarea: true },
];

export default function AdminHome() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/content/home").then((r) => setForm(r.data.data || {})).catch(() => {});
  }, []);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put("/admin/content/home", { data: form });
      toast.success("Ana sayfa içeriği güncellendi");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Hata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-home-page" className="p-10 max-w-4xl">
      <div className="overline text-[#4A6A8F]">İçerik</div>
      <h1 className="font-serif-ap text-4xl text-[#0F2746] mt-3">Ana Sayfa</h1>
      <p className="text-[#3A5170] mt-3">Hero ve tanıtım bölümlerinin metinlerini buradan düzenleyin.</p>

      <form onSubmit={save} className="mt-10 space-y-6">
        {FIELDS.map((f) => (
          <label key={f.key} className="block">
            <span className="overline text-[10px] text-[#4A6A8F] block mb-2">{f.label}</span>
            {f.textarea ? (
              <textarea
                data-testid={`field-${f.key}`}
                value={form[f.key] || ""}
                onChange={onChange(f.key)}
                rows={3}
                className="w-full bg-white border border-[#0F2746]/30 focus:border-[#0F2746] outline-none p-3 text-[#0F2746] resize-none"
              />
            ) : (
              <input
                data-testid={`field-${f.key}`}
                value={form[f.key] || ""}
                onChange={onChange(f.key)}
                className="w-full bg-white border-b border-[#0F2746]/30 focus:border-[#0F2746] outline-none py-2 text-[#0F2746]"
              />
            )}
          </label>
        ))}
        <button
          type="submit"
          disabled={loading}
          data-testid="save-home-btn"
          className="bg-[#0F2746] text-[#F3F5F8] hover:bg-[#081A33] disabled:opacity-50 px-8 py-3 text-xs uppercase tracking-[0.2em] flex items-center gap-2"
        >
          <Save size={14} /> {loading ? "..." : "Kaydet"}
        </button>
      </form>
    </div>
  );
}
